import React, { useState, useEffect, useRef, useMemo }                    from "react";
import CloseBtn                               from 'assets/icons/Close.svg';
import { Form, Modal, Button }                from "react-bootstrap";
import IconPlus                               from 'assets/icons/Plus Circle.svg';
import IconRemove                             from 'assets/icons/Remove.svg';
import MedicalCertificateService              from 'services/medical-certificate.service';
import AuthService                            from 'services/auth.service';
import Spinner                                from 'react-bootstrap/Spinner';

function MedicalCertificateShareModal({mc, setShareModal, showShareModal}) {
  const isEmailsCancelled = useRef(false);

  const defaultEmails = useMemo(() => (mc?.hr_email ? mc?.hr_email : ['']),[mc]);
  const isHr = useMemo(() => (mc?.hr_email ? true : false),[mc]);
  const [emails, setEmails] = useState(defaultEmails); 
  const [submitting, setSubmitting] = useState(false); 

  useEffect(() => {
    setEmails(defaultEmails);
    return () => {
      isEmailsCancelled.current = true;
    };
  }, [defaultEmails]); // eslint-disable-line

  const closeModal = () => {
    setEmails(defaultEmails);
    setSubmitting(false);
    setShareModal(false);
  }

  const addEmail = () => {
    setEmails((prevState) => {
      return [...prevState, ''];
    });
  }

  const emailForm = () => {
    const handleEmailChange = (e, index) => {
      const newState = emails.map((val, i) => {
        if (i === index) {
          return e.target.value;
        }
        return val
      });
      setEmails(newState);
    }

    const removeEmail = (index) => {
      setEmails((prevState) => {
        return prevState.filter(
          (el, i) => i !== index
        )
      });
    }

    return (
      <div>
        {
          emails.map((email, index) => {
            return (
            <div className="d-flex email-row justify-content-center mb-3" key={`email_${index}`}>
              <div className="w-50 position-relative d-flex">
              <Form.Control className="email-field" type="text" name="email" placeholder="Email" onChange={(e) => {handleEmailChange(e, index)}} min={1} value={email} disabled={index === 0 && isHr ? 'disabled' : ''}/>
              {index > 0 && <button className="btn btn-link position-absolute delete-email-btn" onClick={() => {removeEmail(index)}}><img src={IconRemove} alt="delete-icon"/></button>}
              </div>
            </div>)
          })
        }
        <button className="btn btn-link text-danger add-email-btn" onClick={addEmail}>
          <img src={IconPlus} alt="plus-icon" className="plus-icon"/>Add Email
        </button>
      </div>
    );
  }

  const emailsConfirm = () => {
    var error = false;
    var mailFormat = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //eslint-disable-line

    emails.forEach(email => {
      if(!email.match(mailFormat)){
        error = true;
        return;
      }
      if(error) return;
    })

    if(error){
      alert("Invalid Email");
    }else{
      if(window.confirm('Confirm email medical certificate?')){
        sendEmail();
      }
    }
  }

  const sendEmail = () => {
    setSubmitting(true);
    let params = {
      emails: emails
    }
    MedicalCertificateService.sendEmail(mc.id, params).then(
      (data) => {
        setSubmitting(false);
        if(data?.errors){
          alert(data?.errors[0]);
        }
        if(data?.success){
          alert('Email has been send successfully');
          closeModal();
        }
      },
      (error) => {
        setSubmitting(false);
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
        if (error.response.status === 422 && error.response?.data?.errors) {
          alert(error.response?.data?.errors[0]);
        }
      }
    );
  }

  return (
    <Modal size="lg" show={showShareModal} onHide={() => {closeModal()}} backdrop="static" keyboard={false} className="medical-certificate-share-modal">
      <Modal.Header className="justify-content-center">
        <Modal.Title>Send e-MC</Modal.Title>
        <button type="button" className="close" onClick={() => { closeModal() }}>
            <img src={ CloseBtn } alt="modal-close" />
        </button>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="mb-3">Email to HR:</div>
        {emailForm()}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        {submitting ? <Spinner animation="border" className="spinner"/> : <Button variant="danger" className="send-email-btn" onClick={() => emailsConfirm()}>Send</Button> }
      </Modal.Footer>
    </Modal>
  );
}

export default MedicalCertificateShareModal;
